export default __webpack_public_path__ + "static/media/La-Fleurette.d09ad02a.jpg";